import MarketplaceIcon from '@/assets/icons/marketplace.png';
import { Card } from '@/components/atoms';
import { PageHeader } from '@/components/organisms';
import { Layout } from '@/components/templates';

const ProductEnquiriesView = ({ children }) => {
    return (
        <>
            <PageHeader icon={{ src: MarketplaceIcon }} title="Product Enquiries Statistics" />
            <Layout>
                {/* <Card>
          {children.productResults}
        </Card>
        <Divider dashed /> */}
                <Card>{children.userResults}</Card>
            </Layout>
        </>
    );
};

export { ProductEnquiriesView };
